import { FormattedMessage } from 'react-intl';

import { S27Title, S27TitleDisplay } from '@sorare/core/src/atoms/ui/S27Title';
import type { Color } from '@sorare/core/src/style/types';

type Props = {
  color?: Color;
};
export const InviteTitle = ({ color }: Props) => {
  return (
    <S27Title color={color}>
      <FormattedMessage
        defaultMessage="Invite <display>a friend</display>"
        values={{
          display: chunks => <S27TitleDisplay>{chunks}</S27TitleDisplay>,
        }}
      />
    </S27Title>
  );
};
